// src/App.jsx

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar        from './components/Navbar';
import Home          from './pages/Home';
import About         from './pages/About';
import Projects      from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Skills        from './pages/Skills';
import Contact       from './pages/Contact';
import NotFound      from './pages/NotFound';

import Footer   from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        {/* Site header */}
        <Navbar />

        {/* Main content, padded to clear the fixed navbar */}
        <main className="App-content">
          <Routes>
            <Route path="/"               element={<Home />} />
            <Route path="/about"          element={<About />} />
            <Route path="/projects"       element={<Projects />} />
            <Route path="/projects/:slug" element={<ProjectDetail />} />
            <Route path="/skills"         element={<Skills />} />
            <Route path="/contact"        element={<Contact />} />
            <Route path="*"               element={<NotFound />} />
          </Routes>
        </main>

        {/* Persistent footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
